import CardWithdrawal from './CardWithdrawal';

export default CardWithdrawal;
